import { render, staticRenderFns } from "./fansData.vue?vue&type=template&id=2af3bb1d&scoped=true"
import script from "./fansData.vue?vue&type=script&lang=js"
export * from "./fansData.vue?vue&type=script&lang=js"
import style0 from "./fansData.vue?vue&type=style&index=0&id=2af3bb1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af3bb1d",
  null
  
)

export default component.exports